import { Flex, ToogleSwitch, Hint } from "/app/src/component";
import _ from "underscore";
import React from "react";

export default ({ gdprRequire, setGdprRequire }) => {
  const toogleSwitch = {
    on: gdprRequire,
    manual: true,
    onChange: () => {
      setGdprRequire(!gdprRequire);
    },
  };
  const label = {
    color: "black",
    fontSize: "24px",
    fontWeight: "300",
    my: "5px",
  };
  const labelHint = {
    style: { marginTop: "7px", marginLeft: "10px" },
    position: "top",
    tooltip:
      "Besökare måste acceptera GDPR villkor innan de kan öppna chatten",
  };

  return (
    <Flex w="100%" shrink={0}>
      <Flex basis="20%" pt="40px">
        <ToogleSwitch {...toogleSwitch} />
      </Flex>
      <Flex basis="80%" column>
        <Flex {...label}>
          GDPR krav <Hint {...labelHint} />
        </Flex>
        <Flex color="black" fontSize="18px" my="5px" column>
          Aktivera GDPR villkor som visas upp för besökaren.
        </Flex>
      </Flex>
    </Flex>
  );
};



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/ClientChatSettings/Formular/_GDPRRequirement.js